var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 56,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#9B88AF",
    strokeWidth: 1.6,
    cx: 34,
    cy: 28,
    r: 23.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.972 22.606l.3.015a6.579 6.579 0 014.8 2.624 1.098 1.098 0 01-1.757 1.315 4.386 4.386 0 00-6.43-.648l-.185.174-3.277 3.279a4.393 4.393 0 00.054 6.154 4.382 4.382 0 005.955.232l.18-.165 1.876-1.877a1.096 1.096 0 011.642 1.449l-.091.103-1.89 1.89a6.577 6.577 0 01-9.223-.08c-2.472-2.473-2.57-6.432-.26-9.037l.193-.208 3.29-3.292a6.578 6.578 0 014.823-1.928zm12.102-5.677c2.472 2.473 2.57 6.432.26 9.037l-.193.208-3.29 3.292a6.577 6.577 0 01-9.923-.711 1.098 1.098 0 011.757-1.315 4.386 4.386 0 006.43.648l.185-.174 3.277-3.279a4.393 4.393 0 00-.054-6.154 4.383 4.383 0 00-5.957-.23l-.18.165-1.887 1.877a1.096 1.096 0 01-1.638-1.453l.092-.104 1.897-1.887a6.577 6.577 0 019.224.08z",
    fill: "#9B88AF"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#9B88AF",
    strokeWidth: 1.6,
    cx: 34,
    cy: 28,
    r: 23.2
  }))));
}

export default SvgCopyLink;